import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {ReportWrapper} from '../../model/reportWrapper';
import {ApiService} from '../../services/api.service';
import {saveAs} from 'file-saver';
import {UtilityService} from '../../services/utility-service';
import {HttpResponse} from '@angular/common/http';
import {CommonUtils} from '../../services/common-utils';
import {TransactionWrapper} from '../../model/transactionWrapper';
import {Constants} from '../../constants/ebtq-constants';
import {Title} from '@angular/platform-browser';
import {AdhocReportWrapper} from '../../model/AdhocReportWrapper';
import {LoaderService} from '../loader/service/loader.service';
import {interval, Subject} from 'rxjs';
import {switchMap, takeUntil} from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  standalone: false,
  selector: 'app-reports-creiteria',
  templateUrl: './reports-creiteria.component.html',
  styleUrls: ['./reports-creiteria.component.scss']
})
export class ReportsCreiteriaComponent implements OnInit {
  reportType: string;
  reportName: string;
  reportCode: string;
  showServicerNumber: boolean;
  showFanniemaiLoanNumber: boolean;
  showReportingDate: boolean;
  showSubmissionIdField: boolean;
  showActionCodeField: boolean;
  showReportStartAndEndDateFields: boolean;
  reportDateLabel: string;
  showDownloadButton: boolean;
  showDownloadDelimittedAndPdfButton: boolean;
  showDownloadExcelButton: boolean;
  showReportingPeriod: boolean;
  showSellerNumber: boolean;
  showSellerName: boolean;
  showContractNumber: boolean;

  reportingDate: string;
  repEndDate: string;
  repStrtDate: string;
  actnField: string[];
  submissionIdList?: any[];
  selectedSubId?: string;
  fnLnNum: string;
  monthyear: string;
  actionCodes: any[];
  months = [];
  isExternalUser: boolean;
  servicerList: any = [];
  servicerNumber: string;
  sellerNumber: string;
  contractNumber: string;
  sellerName: string;
  warningMessage?: string;
  lastNMonths?: any[];
  errors: string[] = [];
  title = '';
  safePdfURL?:SafeResourceUrl;
  displayDialog = false;
  fileData:Blob;
  fileName: string;
  previousUrl:string;
  constructor(private router: Router,
              private commonUtil: CommonUtils,
              private activatedRoute: ActivatedRoute,
              private location: Location,
              private _apiService: ApiService, private _util: UtilityService, private titleService: Title,
              private _load: LoaderService, public sanitizer: DomSanitizer, private cdr: ChangeDetectorRef) {


    this.actionCodes = [];
    this.actionCodes.push({label: '90-ACTION UNSCHED TAXES', value: '90'});
    this.actionCodes.push({label: '91-ACTION UNSCHED INSURANCE', value: '91'});
    this.actionCodes.push({label: '92-ACTION UNSCHED INSPECTION', value: '92'});
    this.actionCodes.push({label: '93-ACTION UNSCHED APPRAISAL', value: '93'});
    this.actionCodes.push({label: '94-ACTION UNSCHED PROPERTY PRESERVATION', value: '94'});
    this.actionCodes.push({label: '41-UNSCHED RS NOT FINAL', value: '41'});
    this.actionCodes.push({label: '42-UNSCHED FYP NOT FINAL', value: '42'});
    this.actionCodes.push({label: '43-UNSCHED TI SETASIDE', value: '43'});
    this.actionCodes.push({label: '44-UNSCHED NET LINE CREDIT', value: '44'});
    this.actionCodes.push({label: '45-UNSCHED RS FINAL', value: '45'});
    this.actionCodes.push({label: '46-UNSCHED FYP FINAL', value: '46'});
    this.actionCodes.push({label: '47-UNSCHED APPR FOR PAYOFF', value: '47'});
    this.actionCodes.push({label: '48-UNSCHED LOC TAX PAYMENT', value: '48'});
    this.actionCodes.push({label: '49-UNSCHED PAYMENT PLAN CHANGE', value: '49'});
    this.actionCodes.push({label: '103-RECORD SCHEDULED PYMT', value: '103'});
    this.actionCodes.push({label: '80-PARTIAL PREPAYMENT', value: '80'});
    this.actionCodes.push({label: '81-PARTIAL PREPAYMENT INCREASE NLC', value: '81'});
    this.actionCodes.push({label: '82-PARTIAL PREPAYMENT INCREASE RS', value: '82'});
    this.actionCodes.push({label: '83-PARTIAL PREPAYMENT INCREASE TI', value: '83'});
    this.actionCodes.push({label: '84-PARTIAL PREPAYMENT INCREASE FYP', value: '84'});
    this.actionCodes.push({label: '31-PAYOFF DUE TO DEATH', value: ' 31'});
    this.actionCodes.push({label: '32-PAYOFF BORROWER MOVED', value: ' 32'});
    this.actionCodes.push({label: '33-PAYOFF BORROWER PAYOFF', value: '33'});
    this.actionCodes.push({label: '34-PAYOFF OTHER', value: '34'});
    this.actionCodes.push({label: '35-PAYOFF UNKNOWN REASON', value: '35'});
    this.actionCodes.push({label: '65-REPURCHASED', value: '65'});
    this.actionCodes.push({label: '66-REFINANCED', value: '66'});
    this.actionCodes.push({label: 'ACCRUE MIP BB', value: '100'});
    this.actionCodes.push({label: 'ACCRUE MIP PARTIAL PREPAYMENT', value: '112'});
    this.actionCodes.push({label: 'ACCRUE MIP UNSCHED', value: '107'});
    this.actionCodes.push({label: 'ACCRUE MIP SCHEDULED PYMT', value: '104'});
    this.actionCodes.push({label: 'ACCRUE SERVICE FEE', value: '110'});

  }

  ngOnInit(): void {

    const isExternal = JSON.parse(sessionStorage.getItem('isExternal'));
    this.isExternalUser = (isExternal == null) ? false : isExternal;
    this.activatedRoute.queryParams.subscribe(params => {
      this.reportType = params.reportType;
      this.previousUrl = params.previousUrl;

    });

    if (this.reportType !== 'Adhoc Reports') {
      this.title = this.reportType + 's';
    } else {
      this.title = this.reportType;
    }

    this.titleService.setTitle(this.title);

    if (this.isExternalUser) {
      if (sessionStorage.getItem('authServrList') != null) {
        this.servicerList = Array.from(JSON.parse(sessionStorage.getItem('authServrList')));
        this.servicerNumber = this.servicerList[0].value;
      }

    }
    this.reportName = sessionStorage.getItem('reportName');
    this.reportCode = sessionStorage.getItem('reportCode');
    this.showServicerNumber = this.displayServicerNumberFeild();
    this.showFanniemaiLoanNumber = this.displayFannieMaiLoanNumber();
    this.showReportingDate = this.displayReeportingDateFeild();
    this.showSubmissionIdField = this.displaySubmissionIdFeild();
    this.showActionCodeField = this.displayActionCodeFeild();
    this.showReportStartAndEndDateFields = this.displayReportStandAndEndDate();
    this.showReportingPeriod = this.dsiplayReportingPeriod();
    this.showDownloadButton = this.dsiplayDownloadButton();
    this.showDownloadDelimittedAndPdfButton = this.displayDownloadDelimittedAndPdfButton();
    this.showDownloadExcelButton = this.displayDownloadExcelButton();
    this.showSellerNumber = this.displaySellerNumber();
    this.showSellerName = this.displaySellerName();
    this.showContractNumber = this.displayContractNumber();
    this.lastNMonths = this.commonUtil.lastNYearMonths(12, this.reportCode);
    this.monthyear = this.lastNMonths[0].value;
    this.errors = [];

    // Without this, report criteria fields stay blank on first render until an unrelated click triggers change detection
    this.cdr.detectChanges();
  }

  validateInput(isSubmit: boolean) {
    let valid = true;
    this.errors = [];
    this.warningMessage = '';

    // Service Number Field Validation
    if (this.showServicerNumber) {
      if (this.reportType === 'Daily Report' || this.reportType === 'Monthly Report') {
        if (this.showFanniemaiLoanNumber) {
          // both fields are empty
          if (this._util.isEmpty(this.servicerNumber) && this._util.isEmpty(this.fnLnNum)) {
            // download buttons require servicer number, but loan number is not needed
            if (!isSubmit) {
              valid = false;
              this.errors.push(Constants.SELLER_VALIDATION);
            } else {
              valid = false;
              this.errors.push(Constants.AT_LEAST_SRVR_OR_LN_NUM);
            }
          }

          // one of the fields is empty or they both populated
          else {
            // serv number is populated and fn ln number is empty
            if (!this._util.isEmpty(this.servicerNumber) && this._util.isEmpty(this.fnLnNum)) {
              // Covers non-numeric and length requirement scenarios
              if (this._util.isNotNumber(this.servicerNumber) ||
                this._util.getActualLength(this.servicerNumber) !== 9) {
                valid = false;
                this.errors.push(Constants.SELLER_VALIDATION);
              }
            }

            // fn ln number is populated and serv num is empty
            else if (!this._util.isEmpty(this.fnLnNum) && this._util.isEmpty(this.servicerNumber)) {
              // fn ln number is not needed for download
              if (!isSubmit) {
                valid = false;
                this.errors.unshift(Constants.FN_LN_NO_RPT_DOWNLOAD);
                this.errors.push(Constants.SELLER_VALIDATION);
              }

              // Covers non-numeric, length requirement, and valid fannie mae loan number format scenarios
              if (this._util.isNotNumber(this.fnLnNum) || this._util.getActualLength(this.fnLnNum) !== 10
                || this.fnLnNum[0] !== '6') {
                valid = false;
                this.errors.push(Constants.NOT_VALID_LOAN_NUMBER);
              }
            }

            // both are populated
            else {
              // Covers non-numeric and length requirement scenarios
              if (this._util.isNotNumber(this.servicerNumber) ||
                this._util.getActualLength(this.servicerNumber) !== 9) {
                valid = false;
                this.errors.push(Constants.SELLER_VALIDATION);
              }

              // fn ln number is not needed for download
              if (!isSubmit) {
                valid = false;
                this.errors.unshift(Constants.FN_LN_NO_RPT_DOWNLOAD);
              }

              // Covers non-numeric, length requirement, and valid fannie mae loan number format scenarios
              if (this._util.isNotNumber(this.fnLnNum) || this._util.getActualLength(this.fnLnNum) !== 10 ||
                this.fnLnNum[0] !== '6') {
                valid = false;
                this.errors.push(Constants.NOT_VALID_LOAN_NUMBER);
              }
            }
          }
        } else {
          // special case: serv num field can be set as ALL
          if (this.reportCode === 'RPT_RSS_01' || this.reportCode === 'RPT_12') {
            if (this.servicerNumber !== 'ALL') {
              if ((this._util.isNotNumber(this.servicerNumber) || this._util.isEmpty(this.servicerNumber) ||
                this._util.getActualLength(this.servicerNumber) !== 9)) {
                valid = false;
                this.errors.push(Constants.SERVICER_ALL_OR_9_DIGITS);
              }
            }
          } else {
            if ((this._util.isNotNumber(this.servicerNumber) || this._util.isEmpty(this.servicerNumber) ||
              this._util.getActualLength(this.servicerNumber) !== 9)) {
              valid = false;
              this.errors.push(Constants.SELLER_VALIDATION);
            }
          }
        }
      }
    }

    // Action Codes Field Validation
    if (this.showActionCodeField && (this.actnField === null || this.actnField === undefined ||
      this.actnField.length === 0)) {
      valid = false;
      this.errors.push(Constants.NO_ACTN_CD_SELECT);
    }

    // Reporting Date Field Validation
    if (this.showReportingDate && (this.reportingDate === null || this.reportingDate === undefined ||
      this.reportingDate === '')) {
      if (!this.showReportingPeriod && this.reportType !== 'Monthly Report') {
        valid = false;
        this.errors.push(Constants.EMPTY_REPORT_DATE);
      }
    }

    // Report Start Date and End Date Field Validation
    if (this.showReportStartAndEndDateFields) {
      if (this.repStrtDate === null || this.repStrtDate === undefined || this.repStrtDate === '') {
        valid = false;
        this.errors.push(Constants.EMPTY_REPORT_DATE);
      }

      if (this.repEndDate === null || this.repEndDate === undefined || this.repEndDate === '') {
        valid = false;
        this.errors.push(Constants.EMPTY_REPORT_DATE);
      }
    }

    // Submission ID Field Validation
    if (this.showSubmissionIdField) {
      if (this.selectedSubId === undefined || this.selectedSubId === null || this.selectedSubId === '') {
        valid = false;
        this.errors.push(Constants.EMPTY_SUBMISSION_ID);
      }
    }

    // Seller Number Field Validation
    if (this.showSellerNumber) {
      if (this.sellerNumber === undefined || this.sellerNumber === null || this.sellerNumber === '') {
        valid = false;
        this.errors.push(Constants.SELLER_VALIDATION);
      }
    }

    return valid;
  }

  displayFannieMaiLoanNumber() {
    //01,03,04,05,06,07,125
    let flag = false;
    if (this.reportCode === 'RPT_01' ||
      this.reportCode === 'RPT_03' || this.reportCode === 'RPT_04' ||
      this.reportCode === 'RPT_05' || this.reportCode === 'RPT_06' ||
      this.reportCode === 'RPT_07' || this.reportCode === 'RPT_125') {
      flag = true;
    }
    return flag;
  }

  displayServicerNumberFeild() {
    let flag = false;
    //02,03,04,05,07,08,08B,105,12,13,19,20,21,26,27,28,29,31,39
    if (this.reportCode === 'RPT_35' ||
      this.reportCode === 'RPT_RSS_02' || this.reportCode === 'RPT_RSS_01' ||
      this.reportCode === 'RPT_RSS_03' || this.reportCode === 'RPT_01' ||
      this.reportCode === 'RPT_RSS_04' || this.reportCode === 'RPT_02' ||
      this.reportCode === 'RPT_03' || this.reportCode === 'RPT_04' ||
      this.reportCode === 'RPT_05' || this.reportCode === 'RPT_07' ||
      this.reportCode === 'RPT_08' || this.reportCode === 'RPT_08B' ||
      this.reportCode === 'RPT_105' || this.reportCode === 'RPT_12' ||
      this.reportCode === 'RPT_13' || this.reportCode === 'RPT_19' ||
      this.reportCode === 'RPT_20' || this.reportCode === 'RPT_21' ||
      this.reportCode === 'RPT_26' || this.reportCode === 'RPT_27' ||
      this.reportCode === 'RPT_28' || this.reportCode === 'RPT_29' ||
      this.reportCode === 'RPT_31' || this.reportCode === 'RPT_39' || this.reportCode === 'RPT_105') {
      flag = true;
    }
    return flag;
  }

  displayReeportingDateFeild() {
    let flag = false;
    //01,02,03,04,05,06,07,08,08B,100,105,124,128,12,13,14B,19,20,21,24,25A,26,28,29,30a,31,35,38,39,RSS,RSS1,RSS6
    if (this.reportCode === 'RPT_35' ||
      this.reportCode === 'RPT_RSS' || this.reportCode === 'RPT_RSS_01' || this.reportCode === 'RPT_RSS_02' || this.reportCode === 'RPT_RSS_03' ||
      this.reportCode === 'RPT_RSS_06' || this.reportCode === 'RPT_01' || this.reportCode === 'RPT_RSS_04' || this.reportCode === 'RPT_02' ||
      this.reportCode === 'RPT_03' || this.reportCode === 'RPT_04' ||
      this.reportCode === 'RPT_05' || this.reportCode === 'RPT_07' ||
      this.reportCode === 'RPT_08' || this.reportCode === 'RPT_08B' || this.reportCode === 'RPT_100' ||
      this.reportCode === 'RPT_105' || this.reportCode === 'RPT_124' || this.reportCode === 'RPT_128' || this.reportCode === 'RPT_12' ||
      this.reportCode === 'RPT_13' || this.reportCode === 'RPT_14B' || this.reportCode === 'RPT_19' ||
      this.reportCode === 'RPT_20' || this.reportCode === 'RPT_21' || this.reportCode === 'RPT_24' || this.reportCode === 'RPT_25A' ||
      this.reportCode === 'RPT_26' || this.reportCode === 'RPT_28' || this.reportCode === 'RPT_30a' || this.reportCode === 'RPT_30' ||
      this.reportCode === 'RPT_22' || this.reportCode === 'RPT_25' || this.reportCode === 'RPT_25a' ||
      this.reportCode === 'RPT_31' || this.reportCode === 'RPT_38' || this.reportCode === 'RPT_39') {
      flag = true;
    }

    if (this.reportCode === 'RPT_13') {
      this.reportDateLabel = 'Disbursement Date';
    } else if (this.reportCode === 'RPT_24') {
      this.reportDateLabel = 'Processing Date';
    } else if (this.reportCode === 'RPT_28') {
      this.reportDateLabel = 'Reporting Date (YYYYMM)';
    } else if (this.reportCode === 'RPT_RSS' || this.reportCode === 'RPT_RSS_01' || this.reportCode === 'RPT_RSS_02' || this.reportCode === 'RPT_RSS_03' || this.reportCode === 'RPT_RSS_04') {
      this.reportDateLabel = 'Remittance Date';
    } else {
      this.reportDateLabel = 'Report Date';
    }

    return flag;
  }

  displaySubmissionIdFeild() {
    let flag = false;
    //28,29
    if (this.reportCode === 'RPT_28' ||
      this.reportCode === 'RPT_29') {
      flag = true;
    }
    return flag;
  }


  displayActionCodeFeild() {
    let flag = false;
    //13
    if (this.reportCode === 'RPT_13') {
      flag = true;
    }
    return flag;
  }

  displayReportStandAndEndDate() {
    let flag = false;
    if (this.reportType === 'Date Range Report' || this.reportCode === 'RPT_24a' || this.reportCode === 'RPT_115') {
      flag = true;
    }
    return flag;
  }

  dsiplayReportingPeriod() {
    let flag = false;
    //27,28
    if (this.reportCode === 'RPT_27' || this.reportCode === 'RPT_28' || this.reportCode === 'RPT_29'
      || this.reportCode === 'RPT_06' || this.reportCode === 'RPT_09' || this.reportCode === 'RPT_10'
      || this.reportCode === 'RPT_11' || this.reportCode === 'RPT_15' || this.reportCode === 'RPT_16'
      || this.reportCode === 'RPT_17' || this.reportCode === 'RPT_18' || this.reportCode === 'RPT_23'
      || this.reportCode === 'RPT_32' || this.reportCode === 'RPT_33' || this.reportCode === 'RPT_34'
      || this.reportCode === 'RPT_34' || this.reportCode === 'RPT_36' || this.reportCode === 'RPT_37'
      || this.reportCode === 'RPT_40' || this.reportCode === 'RPT_100' || this.reportCode === 'RPT_105'
      || this.reportCode === 'RPT_103' || this.reportCode === 'RPT_12B' || this.reportCode === 'RPT_RSS_06'
      || this.reportCode === 'RPT_102' || this.reportCode === 'RPT_104' || this.reportCode === 'RPT_126') {
      flag = true;
    }
    return flag;
  }

  dsiplayDownloadButton() {
    let flag = false;
    //35,14B
    if (this.reportCode === 'RPT_35' || this.reportCode === 'RPT_14B') {
      flag = true;
    }
    return flag;
  }

  displayDownloadDelimittedAndPdfButton() {
    //01,02,03,04,05,07,08,26,28,28,38
    let flag = false;

    if (
      this.reportCode === 'RPT_01' ||
      this.reportCode === 'RPT_02' ||
      this.reportCode === 'RPT_03' || this.reportCode === 'RPT_04' ||
      this.reportCode === 'RPT_05' || this.reportCode === 'RPT_07' ||
      this.reportCode === 'RPT_08' || this.reportCode === 'RPT_26' || this.reportCode === 'RPT_28'
      || this.reportCode === 'RPT_38' || this.reportCode === 'RPT_29') {
      flag = true;
    }
    return flag;
  }

  /**
   * Method to display downloadExcel button
   */
  displayDownloadExcelButton() {
    let flag = false;

    // Show the download excel buttong for following reports only
    if ( this.reportCode === 'RPT_RSS_01' || this.reportCode === 'RPT_01' ||
        this.reportCode === 'RPT_08' || this.reportCode === 'RPT_09' ||
        this.reportCode === 'RPT_24a' || this.reportCode === 'RPT_24' || 
        this.reportCode === 'RPT_26' || //this.reportCode == 'RPT_28' || 
        this.reportCode === 'RPT_29' || this.reportCode === 'RPT_39' ||
        this.reportCode === 'RPT_23' || this.reportCode === 'RPT_36') {

      flag = true;
    }

    return flag;
  }

  displaySellerNumber() {
    let flag = false;
    if (this.reportCode === 'RPT_111' || this.reportCode === 'RPT_113' || this.reportCode === 'RPT_100') {
      flag = true;
    }
    return flag;
  }

  displaySellerName() {
    let flag = false;
    if (this.reportCode === 'RPT_114') {
      flag = true;
    }
    return flag;
  }

  displayContractNumber() {
    let flag = false;
    //122
    if (this.reportCode === 'RPT_112') {
      flag = true;
    }
    return flag;
  }

  onClear() {
    this.reportingDate = '';
    this.repEndDate = '';
    this.repStrtDate = '';
    this.actnField = [];
    this.selectedSubId = '';
    this.fnLnNum = '';
    this.warningMessage = '';
    if (!this.isExternalUser) {
      this.servicerNumber = '';
    }
    this.errors = [];
    this.sellerNumber = '';
    this.monthyear = this.lastNMonths[0].value;
  }

  getSubmissionId() {

    // Clear errors
    this.errors = [];
    this.warningMessage = '';

    if (!this.servicerNumber) {
      this.errors.push(Constants.SELLER_VALIDATION);
    }

    if (this._util.isNotNumber(this.servicerNumber) && !this._util.isEmpty(this.servicerNumber)) {
      this.errors.push(Constants.SELLER_VALIDATION);
    }

    if (!this.monthyear) {
      this.errors.push('Please select report date');
    }
    if (this.errors.length > 0) {
      return;
    }
    const transactionWrapper = new TransactionWrapper();
    transactionWrapper.queryServiceName = Constants.GET_SUBMISSION_IDS;
    transactionWrapper.parameters[0] = this.monthyear.substring(4) + '/01/' + this.monthyear.substring(0, 4);
    transactionWrapper.parameters[1] = this.servicerNumber;
    this._apiService.executeQuery(transactionWrapper).subscribe(
      (data: any) => {
        if (data.object.length > 0) {
          this.submissionIdList = data.object;
          this.selectedSubId = data.object[0].submissionId;
        } else {
          this.warningMessage = Constants.NO_RETURNED_DATA;
        }
        this.cdr.detectChanges();
      },
      (err) => {
        this.warningMessage = err;
        this.cdr.detectChanges();
      });
  }

  onCancelClick() {
    this.router.navigate([this.previousUrl]);
  }

  submit() {
    if (this.fnLnNum !== undefined && this.fnLnNum !== '' && (this.reportType === 'Monthly Report' || this.reportType === 'Daily Report')) {
      this.errors = [];
      this.validFanniemaeLnNbr(this.fnLnNum);

    } else {
      this.callDownload('pdf', true);
    }
  }

  onDownloadPdf() {
    this.callDownload('pdf', false);
  }

  /**
   * Method to download excel report
   */
  onDownloadEXCEL() {
    this.warningMessage = '';
    this.errors = [];
    const wrp = new AdhocReportWrapper();

    //set the reportName
    wrp.reportName = this._util.getReportNameByRPT(this.reportCode);
    wrp.exportFormat = 'XLS';

    if (this.reportCode === 'RPT_01' || this.reportCode === 'RPT_RSS_01'
    || this.reportCode === 'RPT_08' || this.reportCode === 'RPT_09'
    || this.reportCode === 'RPT_24a' || this.reportCode === 'RPT_24' 
    || this.reportCode === 'RPT_26' || this.reportCode === 'RPT_28' 
    || this.reportCode === 'RPT_29' || this.reportCode === 'RPT_39') {
      if (!this.validateInput(false)) {
        return;
      }
    }

    if (this.reportCode === 'RPT_RSS_01') {
      wrp.reportName = 'RSS_' + wrp.reportName;
    }

    // Download excel for adhoc report
    if (this.reportCode === 'RPT_24a') {
      const startDt = this.convertDate(this.repStrtDate);
      const endDt = this.convertDate(this.repEndDate);
      wrp.parameters.push(startDt);
      wrp.parameters.push(endDt);
      this._load.isLoaderOn.next(true);

      this._apiService.generateAdhocReport(wrp).subscribe((res) => {
        this.retrieveFile(res.fileName, false);
      }, (err) => {
        this.warningMessage = err;
        this._load.isLoaderOn.next(false);
        this.cdr.detectChanges();
      });

      return;
    }

    // Add loannumber as ALL and servicernumber for Report 01
    if (this.reportCode === 'RPT_01') {
      wrp.parameters.push('ALL');
      wrp.parameters.push(this.servicerNumber);
    } else if ('RPT_24' !== this.reportCode && 'RPT_36' !== this.reportCode
      && 'RPT_09' !== this.reportCode && 'RPT_23' !== this.reportCode) {
      if (this.showSellerNumber) {
        wrp.parameters.push(this.sellerNumber);
      } else if (this.showSubmissionIdField) {
        wrp.parameters.push(this.servicerNumber + '.' + this.selectedSubId);
      } else {
        wrp.parameters.push(this.servicerNumber);
      }
    }

    // Download excel for monthly and daily reports
    if (this.reportType === 'Monthly Report') {
      wrp.parameters.push(this.monthyear.substr(4) + '/' + this.monthyear.substr(0, 4));
    } else if (this.reportType === 'Daily Report') {
      //Reports 28 and 29 have monthly dropdown
      if (this.showReportingPeriod) {
        wrp.parameters.push(this.monthyear.replace(/(\d{4})(\d\d)/, '$2/01/$1'));
        // Duplicating the line for report extraction from SAP BO CMC
        wrp.parameters.push(this.monthyear.replace(/(\d{4})(\d\d)/, '$2/01/$1'));
      } else {
        wrp.parameters.push(this._util.convertMillisecToDate(this.reportingDate));
      }
    }

    this._apiService.getReportByLoanNumber(wrp).subscribe((res) => {

      this.fileName = (res.headers.get('Content-Disposition').split('filename='))[1];
      this.fileName = this.fileName.replace('_' + this.reportCode, '');

      saveAs(res.body, this.fileName);
    }, () => {
      this.warningMessage = 'No matching report found for the selected search criteria.';
      this.cdr.detectChanges();
    });

  }

  onDownloadDat() {
    this.callDownload('dat', false);
  }

  private callDownload(fileType: string, isSubmit: boolean) {
    this.warningMessage = '';
    this.errors = [];
    if (this.reportType === 'Adhoc Reports') {
      this.downloadAdhocReport();
      return;
    }
    if (!this.validateInput(isSubmit)) {
      return;
    }
    const wrp = new ReportWrapper();
    wrp.fileType = fileType;
    wrp.reportCode = this.reportCode;
    wrp.reportType = this.reportType;

    if (this.reportType !== undefined && this.reportType !== '') {
      if (this.reportType === 'Monthly Report') {
        wrp.reportingPeriod = this.monthyear;
      } else if (this.reportType === 'Daily Report') {
        if (this.showReportingPeriod) {
          wrp.reportingPeriod = this.monthyear.replace(/(\d{4})(\d\d)/, '$2/01/$1');
        } else {
          wrp.reportingPeriod = this._util.convertMillisecToDate(this.reportingDate);
        }
      } else {
        wrp.reportingPeriod = this._util.convertMillisecToDate(this.reportingDate);
      }
    }

    wrp.reportingPeriodType = this.reportType;

    if ('RPT_24' !== wrp.reportCode) {
      if (this.showSellerNumber) {
        wrp.sellerNumber = this.sellerNumber;
      } else if (this.showSubmissionIdField) {
        wrp.servicerNumber = this.servicerNumber + '.' + this.selectedSubId;
      } else {
        wrp.servicerNumber = this.servicerNumber;
      }
    }

    if (wrp.reportCode === 'RPT_14B') {
      wrp.fileType = 'csv';
    } else if (wrp.reportCode === 'RPT_35') {
      wrp.fileType = 'dat';
    }
    this._apiService.downloadReport(wrp).subscribe((data: HttpResponse<Blob>) => {
      this.fileName = (data.headers.get('Content-Disposition').split('filename='))[1];
      this.fileName = this.fileName.replace('_.', '_');
      this.fileName = this._util.getReportNameByRPT(this.reportCode)
        + '_' + this.fileName.replace('_' + this.reportCode, '');
      this.fileName = this.fileName.replace('.' + this.reportCode, '');

      if (isSubmit && wrp.reportCode !== 'RPT_35' && wrp.reportCode !== 'RPT_14B') {
        const blob = new Blob([data.body], {type: 'application/' + wrp.fileType});
        const fileURL = window.URL.createObjectURL(blob) + '#toolbar=0';
        this.safePdfURL = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
        this.displayDialog = true;
        this.fileData = data.body;
      } else {
        this.fileData = data.body;

        saveAs(data.body, this.fileName);
      }
      this.cdr.detectChanges();
    }, async () => {
      this.warningMessage = 'No matching report found for the selected search criteria.';
      this.cdr.detectChanges();
    });
  }

  private downloadReportByFnLn() {
    const isValid = true;
    this._load.isLoaderOn.next(true);
    // Validation for both Fnln number and servicer number.
    if (!this.validateInput(true)) {
      this._load.isLoaderOn.next(false);
      return;
    }
    const wrp = new AdhocReportWrapper();
    if (this.reportCode === 'RPT_01') {
      wrp.reportName = 'Disbursement_Reconciliation_Detail_Report';
    } else if (this.reportCode === 'RPT_03') {
      wrp.reportName = 'Net_Principal_Limit_Report';
    } else if (this.reportCode === 'RPT_04') {
      wrp.reportName = 'LOC_Reserve_Report';
    } else if (this.reportCode === 'RPT_05') {
      wrp.reportName = 'Loan_Adjustment_Detailed_Listing_Report';
    } else if (this.reportCode === 'RPT_07') {
      wrp.reportName = 'Portfolio_Loan_Balance_Summary_Listing_Report';
    }

    /* Loan number parameter */
    wrp.parameters.push(this.fnLnNum);

    /* Servicer number parameter and validation */
    if (this.servicerNumber !== undefined && this.servicerNumber !== '') {
      wrp.parameters.push(this.servicerNumber);
    } else {
      wrp.parameters.push('ALL');
    }

    /* reporting period parameter based on monthly/daily reports */
    if (this.reportType === 'Monthly Report') {
      wrp.parameters.push(this.monthyear.substr(4) + '/' + this.monthyear.substr(0, 4));
    } else if (this.reportType === 'Daily Report') {
      wrp.parameters.push(this._util.convertMillisecToDate(this.reportingDate));
    }

    if (isValid) {
      this._apiService.getReportByLoanNumber(wrp).subscribe((res) => {

        this.fileName = (res.headers.get('Content-Disposition').split('filename='))[1];
        this.fileName = this.fileName.replace('_' + this.reportCode, '');

        const blob = new Blob([res.body], {type: 'application/pdf'});
        const fileURL = window.URL.createObjectURL(blob) + '#toolbar=0';
        //window.open(fileURL, '_blank');
        this.safePdfURL = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
        this.displayDialog = true;
        this.fileData = res.body;
        this.cdr.detectChanges();
      }, () => {
        this.warningMessage = 'No matching report found for the selected search criteria.';
        this._load.isLoaderOn.next(false);
        this.cdr.detectChanges();
      });
    }
  }

  private downloadAdhocReport() {
    let isValid = true;
    this._load.isLoaderOn.next(true);
    const wrp = new AdhocReportWrapper();
    if ('RPT_06' === this.reportCode) {
      isValid = false;
      this.validateReportDate(this.monthyear, Constants.MONTHLY_REPORT);
      this.validFanniemaeLnNbr(this.fnLnNum);
    } else if ('RPT_13' === this.reportCode) {
      wrp.reportName = 'Servicing_Disbursement_Verification_Report';
      const rptDt = this.convertDate(this.reportingDate);
      this.validServicerNbr(this.servicerNumber);
      this.validActionFields(wrp);
      this.validateReportDate(rptDt, Constants.DAILY_REPORT);
      isValid = this.errors.length === 0;
      wrp.parameters.push(this.servicerNumber);
      wrp.parameters.push(rptDt);
    } else if ('RPT_24a' === this.reportCode || 'RPT_115' === this.reportCode) {
      wrp.reportName = ('RPT_24a' === this.reportCode) ? 'Manual_Load_Summary_Adhoc_Report' : 'Index_Rate_Report';
      const startDt = this.convertDate(this.repStrtDate);
      const endDt = this.convertDate(this.repEndDate);
      this.validateReportDate(startDt, Constants.DAILY_REPORT);
      this.validateReportDate(endDt, Constants.DAILY_REPORT);
      isValid = this.errors.length === 0;
      wrp.parameters.push(startDt);
      wrp.parameters.push(endDt);
    } else if ('RPT_111' === this.reportCode || 'RPT_113' === this.reportCode) {
      wrp.reportName = ('RPT_111' === this.reportCode) ? 'Contract_List_by_SellerNumber_Report' : 'Seller_Servicer_Info_Report';
      isValid = this.isValidSellerNumber(this.sellerNumber);
      wrp.parameters.push(this.sellerNumber);
    } else if ('RPT_112' === this.reportCode) {
      wrp.reportName = 'Contract_Details_by_ContractNumber_Report';
      isValid = this.isValidContractNumber(this.contractNumber);
      wrp.parameters.push(this.contractNumber);
    } else if ('RPT_114' === this.reportCode) {
      wrp.reportName = 'Seller_Servicer_Info_by_Name_Report';
      isValid = this.isValidSellerName(this.sellerName);
      wrp.parameters.push(this.sellerName);
    } else if ('RPT_125' === this.reportCode) {
      isValid = false;
      this.validFanniemaeLnNbr(this.fnLnNum);
    } else {
      wrp.reportName = ('RPT_25a' === this.reportCode) ? 'Detailed_Liquidation_Adhoc_Report' :
        ('RPT_124' === this.reportCode) ? 'Loan_Modification_Report' : 'Servicers_Trial_Balance_Status_Report';
      const rptDt = this.convertDate(this.reportingDate);
      isValid = this.validateReportDate(rptDt, Constants.DAILY_REPORT);
      wrp.parameters.push(rptDt);

    }
    if (isValid) {
      this._apiService.generateAdhocReport(wrp).subscribe((res) => {
        this.retrieveFile(res.fileName, true);
      }, (err) => {
        if (err.error && err.error.message) {
          this.warningMessage = err.error.message;
        } else {
          this.warningMessage = err;
        }
        this._load.isLoaderOn.next(false);
        this.cdr.detectChanges();
      });
    } else {
      this._load.isLoaderOn.next(false);
    }
  }

  retrieveFile(fileName: string, isPdf: boolean): void {
    const stopPolling = new Subject<void>();
    let loopCnt = 0;
    fileName = fileName.replace(',', '_');
    const pollStartTime = Date.now();
    interval(9000).pipe(
      switchMap(() => this._apiService.checkAdhocReportGenerated(fileName)),
      takeUntil(stopPolling)
    ).subscribe((data: any) => {
      loopCnt = loopCnt + 1;
      const elapsedSec = ((Date.now() - pollStartTime) / 1000).toFixed(0);
      // Check if background report generation failed (error propagated from Crystal server)
      if (typeof data === 'string' && data.startsWith('Report generation failed:')) {
        stopPolling.next();
        this.warningMessage = data;
        this._load.isLoaderOn.next(false);
        this.cdr.detectChanges();
        return;
      }
      // API still reports no matching report found - keep polling, but stop after 10 tries with the API's own message
      if ('No Matching Report Found' === data) {
        if (loopCnt > 10) {
          stopPolling.next();
          this.warningMessage = 'No matching report found for the selected search criteria.';
          this._load.isLoaderOn.next(false);
          this.cdr.detectChanges();
        }
        return;
      }
      if (typeof data === 'string') {
        stopPolling.next();
        this.warningMessage = data;
        this._load.isLoaderOn.next(false);
        this.cdr.detectChanges();
        return;
      }
      if (loopCnt > 10) {
        stopPolling.next();
        this.warningMessage = 'Report generation timed out after ' + elapsedSec + ' seconds. The SAP BO Crystal server may be slow or the report failed to generate.';
        this._load.isLoaderOn.next(false);
        this.cdr.detectChanges();
        return;
      }
      this.fileName = (data.headers.get('Content-Disposition').split('filename='))[1];
      this.fileName = this.fileName.replace('_' + this.reportCode, '');
      if (isPdf) {
        const blob = new Blob([data.body], {type: 'application/pdf'});
        const fileURL = window.URL.createObjectURL(blob) + '#toolbar=0';
        this.safePdfURL = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
        this.displayDialog = true;
        this.fileData = data.body;
      } else {
        saveAs(data.body, this.fileName);
      }
      stopPolling.next();
      this._load.isLoaderOn.next(false);
      this.cdr.detectChanges();
    }, (err) => {
      stopPolling.next();
      if (err.error && err.error.message) {
        this.warningMessage = err.error.message;
      } else {
        this.warningMessage = err;
      }
      this._load.isLoaderOn.next(false);
      this.cdr.detectChanges();
    });
  }

  private validateReportDate(rptDate: string, rptPeriodType: string) {
    if (this._util.isBlank(rptDate)) {
      this.errors.push('Empty Reporting Date is not allowed');
      return false;
    } else if (Constants.MONTHLY_REPORT === rptPeriodType && rptDate.length !== 6) {
      this.errors.push('Please check the date format is YYYYMM');
      return false;
    } else if (this._util.containsIllegalCharacter(rptDate)) {
      this.errors.push('Reporting Period contains invalid characters');
      return false;
    } else if (Constants.DAILY_REPORT === rptPeriodType && !this._util.isValidDate(rptDate)) {
      this.errors.push('Please check the date format is MM/DD/YYYY');
      return false;
    }
    return true;
  }

  private validFanniemaeLnNbr(loanNo: string) {
    if (this._util.isBlank(loanNo) || loanNo.trim().length !== 10
      || !this._util.isLong(loanNo) || !(loanNo.startsWith('6'))) {
      this.errors.push('Only the following sequence will qualify for Loan Number: \'6\' followed by 9 digits.');
    }
    if (this._util.isNotBlank(this.fnLnNum) && this.errors.length === 0) {
      this.isUserAuthorizedForLoanNumber(this.fnLnNum);
    }

  }

  private convertDate(inputDt: any | string) {
    return (inputDt === null || inputDt === undefined) ? inputDt : this._util.convertMillisecToDate(inputDt);
  }

  private validServicerNbr(srvrNbr: string) {
    if (this._util.isBlank(srvrNbr) || (srvrNbr.trim().length !== 9
      || !this._util.isLong(srvrNbr))) {
      if (!('ALL' === srvrNbr)) {
        this.errors.push('Servicer Number should be either ALL or 9 digits');
        return false;
      }
    }
    if (this.isExternalUser && this._util.isNotBlank(this.servicerNumber) && this.errors.length === 0) {
      if (!this._util.isUserAuthorizedForServicerNumber(this.servicerNumber)) {
        this.errors.push('User not authorized for servicer number: ' + this.servicerNumber);
        return false;
      }
    }
    return true;
  }

  private validActionFields(wrp: AdhocReportWrapper) {
    let codesParam = '';
    if (this.actnField === undefined || this.actnField.length === 0) {
      this.errors.push('One or more action code must be selected');
      return false;
    } else {
      for (let i = 0; i < this.actnField.length; i++) {
        const code = this.actnField[i];
        if (this._util.isNotBlank(code)) {
          if (this._util.containsIllegalCharacter(code)) {
            this.errors.push('Action Code contains invalid characters');
            return false;
          } else {
            if (i !== 0) {
              codesParam = codesParam.concat(',');
            }
            codesParam = codesParam.concat(code);
          }
        }
      }
    }
    wrp.parameters.push(codesParam);
    return true;
  }

  private isValidSellerNumber(slrNbr: string) {
    if (this._util.isBlank(slrNbr) || (slrNbr.trim().length !== 9
      || !this._util.isLong(slrNbr))) {
      this.errors.push('Seller number must be 9 digits.');
      return false;
    }
    return true;
  }

  private isValidSellerName(slrName: string) {
    if (this._util.isBlank(slrName)) {
      this.errors.push('Please enter a Seller Name.');
      return false;
    } else if (slrName.trim().length > 40) {
      this.errors.push('Seller Name is invalid');
      return false;
    }
    return true;

  }

  private isValidContractNumber(cntrNbr: string) {
    if (this._util.isBlank(cntrNbr)) {
      this.errors.push('Please enter a Contract Number.');
      return false;
    } else if (this._util.containsIllegalCharacter(cntrNbr)) {
      this.errors.push('Contract Number contains invalid characters');
      return false;
    }
    return true;
  }

  isUserAuthorizedForLoanNumber(loanNbr: string) {
    if (!this.isExternalUser && (this.reportType === 'Monthly Report' || this.reportType === 'Daily Report')) {
      this.downloadReportByFnLn();
      return;
    }
    const transactionWrapper = new TransactionWrapper();
    transactionWrapper.queryServiceName = Constants.QUERY_SERV_NAME;
    transactionWrapper.parameters[0] = loanNbr;
    this._apiService.executeQuery(transactionWrapper)
      .subscribe(
        (data: any) => {
          if (data.object[0] === undefined || data.object[0].SRVR_NO === undefined
            || data.object[0].SRVR_NO === null) {
            if (this.reportType === 'Monthly Report' || this.reportType === 'Daily Report') {
              this.warningMessage = Constants.LOAN_NOT_ACTIV;
            } else {
              this.errors.push(Constants.LOAN_NOT_ACTIV);
            }
            this.cdr.detectChanges();
          } else {
            const srvrNo = data.object[0].SRVR_NO;
            if (!this._util.isUserAuthorizedForServicerNumber(srvrNo)) {
              if (this.reportType === 'Monthly Report' || this.reportType === 'Daily Report') {
                this.warningMessage = 'User not authorized for Loan: ' + this.fnLnNum;
              } else {
                this.errors.push('User not authorized for Loan: ' + loanNbr);
              }
              this.cdr.detectChanges();
            } else {
              if (this.reportType === 'Monthly Report' || this.reportType === 'Daily Report') {
                this.downloadReportByFnLn();
              } else {
                this._load.isLoaderOn.next(true);
                const wrp = new AdhocReportWrapper();
                if ('RPT_125' === this.reportCode) {
                  wrp.reportName = 'Loan_Modification_By_LoanNo_Report';
                  wrp.parameters.push(this.fnLnNum);
                } else {
                  wrp.reportName = 'Portfolio_Loan Balance_Detailed_Listing_Report';
                  if ('RPT_06' === this.reportCode) {
                    wrp.parameters.push('ALL');
                  } else {
                    wrp.parameters.push(srvrNo);
                  }
                  wrp.parameters.push(this.fnLnNum);
                  wrp.parameters.push(this.monthyear.substring(4) + '/' + this.monthyear.substring(0, 4));
                }
                this._apiService.generateAdhocReport(wrp).subscribe((res) => {
                  this.retrieveFile(res.fileName, true);
                }, (err) => {
                  if (err.error && err.error.message) {
                    this.warningMessage = err.error.message;
                  } else {
                    this.warningMessage = err;
                  }
                  this._load.isLoaderOn.next(false);
                  this.cdr.detectChanges();
                });
              }

            }
          }
        },
        error => {
          this.warningMessage = error;
          this.cdr.detectChanges();
        });
  }

  downloadFile() {
    saveAs(this.fileData, this.fileName);
  }

  reportPrint() {
    const iframe = document.getElementById('pdfRendererIframe') as  HTMLIFrameElement;
    iframe.contentWindow.print();

  }
}
